import type { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';

import { bannerSlotKey } from '@core/tellent-assistant-types';

import { TellentAssistantSuggestionsActions } from './suggestions.state';
import { TellentAssistantHttp } from '../tellent-assistant.http';

export const loadTellentAssistantSuggestions = createEffect(
  (actions$ = inject(Actions), http = inject(TellentAssistantHttp)) =>
    actions$.pipe(
      ofType(TellentAssistantSuggestionsActions.fetchOne),
      mergeMap(action => {
        const slot = action.payload.slot;
        const id = bannerSlotKey(slot);
        return http.fetchSuggestions(slot).pipe(
          map(suggestions =>
            TellentAssistantSuggestionsActions.fetchOneSuccess({
              payload: { data: { id, slot: slot.slot, suggestions } },
            }),
          ),
          catchError((error: HttpErrorResponse) =>
            of(
              TellentAssistantSuggestionsActions.fetchOneFailed({
                payload: { id, error },
              }),
            ),
          ),
        );
      }),
    ),
  { functional: true },
);
